/* eslint-disable no-alert */
/* eslint-disable */
import React, { createRef, Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ExpandCollapse } from '@tds/core-expand-collapse';
import Modal from '@tds/community-modal';
import { isEmpty, set, cloneDeep } from 'lodash';
import Heading from '@tds/core-heading';
import request from '../utils/request';
import FormField from './formField';
import ValidateLoader from '../UI/validateLoader';
import LandingText from './WLS/LandingText';
import WlsStatusBar from '../design/wlsStatusBar';
import ProgressBar from '../design/progressBar';
import UserDetailsForm from './userDetailsForm';
import WirelessOrderDetails from './wirelessOrderDetails';
import Note from '../note';
import FormSummaryGroup from './formSummaryGroup';
import RepeatedForm from './repeatedForm';
import { msgDisplay, getFieldValue } from './utils';
import { isRelatedFieldExisted, getFormData } from './formStepWLSUtils';
import { findField } from './formStepUtils';
import { useTranslationsContext } from '../context/TranslationsContext';
import { Image } from '../design/elements';
import { useLocaleContext } from '../context/LocaleContext';
import {
  FormFieldsWrapper,
  GroupTitle,
  GroupWrapper,
  SummaryGroupWrapper,
  FormStepImageContainer
} from './css';
import {
  BACKEND_KEYS,
  fieldKeyAddress,
  typeCheckbox,
  maxUploadSizeValueWLS,
  maxUploadSizeErrorMessageWLS,
  wirelessAdditionalDocumentsOne,
  wirelessAdditionalDocumentsTwo,
  wirelessAdditionalDocumentsComments,
  description,
  errorInMSS,
  mssDefects,
  smbSales,
  inputTypeFile,
  keyFileSizeExceeded,
  roleLabels,
  localeFrench,
  stepKeyMain,
  wirelessLandingPageForm,
  categoryWireless,
  wirelessOrderForm,
  reasonForSubmission,
  sourceOfSaleWLS,
  smbOnlineOrder,
  // albertaAndBritish,
  hardwarePaidAlready,
  omsParentOrderNumber,
  activationType,
  activationTypeListOne,
  activationTypeListTwo,
  activationTypeListThree,
  addOnActivation,
  customerLocation,
  newWirelessActivation,
  customerFacingActivation,
  productSelectionWLS,
  wireless,
  renewal,
  isThisHealth,
  agentNameSalesRep,
  agentEmailAddress,
  outletSalesRep,
  idSalesRep,
  contactNumberSalesRep,
  tIDxIDSalesRep,
  channelNameSalesRep,
  smbIndirectChannelSalesRep,
  channelManagerSalesRep,
  channelManagerEmailAddress,
  tradeNameWLS,
  telusAccountNumberCustomerInformation,
  addOnAndNewWireless,
  // Yes,
  No,
  isCustomerOwner,
  website,
  addAuthorisedContact,
  fullNameWLS,
  pinCode,
  additionalCommentsNote,
  signupForEBill,
  // smsNumber,
  visitedShippingAddress,
  fieldActivationLanguage,
  inkerosEastWestChannels,
  smbIndirectSalesChannel,
  sbsTISalesChannel,
  DevicesOnlyEnglish,
  DevicesOnlyFrench,
  AccessoriesOnlyEnglish,
  AccessoriesOnlyFrench,
  devicesOnlyProductSelection,
  orderNotEligibleforMssReason,
  fieldInstallationTypeWLS,
  requiresDirectorsApproval,
  directorsName,
  directorsEmail,
  reasonForSubOptionsEN,
  reasonForSubOptionsFR,
  accountType,
  channelTicketNumber,
  spocTicketNumber,
  mssDefectTeam,
  BCX_CARE,
  SMB_Sales,
  fieldIssueSummary,
  fieldExpectedBehavior,
  fieldCurrentBehaviour,
  fieldOriginalMssOrderNumber,
  fieldPromoNameThatExpired,
  fieldDatePromoExpired,
  fieldScreenshotOfSavedOrderInMSS,
  files,
  WLSRestrictedChannelsForOrderCreation,
  WLSRestrictedReasonForSubmissionForChannels,
  WLSRestrictedOrderIsNotEligibleForMSSForChannels,
  minimum16SubscribersErrorMessage,
  minimum16SubscribersErrorMessageDefault,
  keyDirectorApprovalRequired,
  directorApprovalDocRequired,
  sevenX,
  fieldSubscriberProvince,
  valueQuebec,
  fieldInboundOutbound,
  numberOfSubscribers,
  wlsBusinessLegalName,
  fieldBusinessRegular,
  fieldBusinessRegularFr,
  fieldWLSIncorporationNumber,
  fieldWLSIncorporationDate,
  WLSPendingValidationReasons,
  fieldWirlessConfirmationCustomer,
  fieldLeadID
} from '../utils/constant';
import { localeFr, getPathVariables } from '../misc';
import OrderSummary from './orderSummary/wls';
import EN from '../../EN.json';
import FR from '../../FR.json';
import { scrollToErrors } from '../utils/utils';

const formFieldsGroup = 'formFieldsGroup';
const formSection = 'formSection';
const userDetailsKey = 'userDetails';
const repeatedFormKey = 'repeatedForm';
const typeMultiCheckbox = 'MultiCheckbox';
const formSectionTitle = 'formSectionTitle';
const profile = request.getProfile();
const FormStepWLS = ({
  stepData,
  steps,
  step,
  updateStep,
  history,
  setFormRef,
  onFormSubmit,
  onSaveAndExit,
  orderData,
  setOrderData,
  hideProgressBar,
  isEditing,
  formName
}) => {
  if (!stepData) return null;

  const translations = useTranslationsContext();
  const locale = useLocaleContext();
  const {
    contentfulValues: { yes, no, valueEnglish, valueFrench },
    formButtons: { confirmButtonLabel, cancelButtinLabel },
    summaryForm: { summaryLabel },
    formStep: {
      //businessRegularMedium,
      creditCheck,
      otherAuthorizedContact,
      subscriptionToEbill,
      minValueErrorMessage,
      maxValueErrorMessage,
      minLengthErrorMessage,
      maxLengthErrorMessage,
      pinNotStartWithZero,
      pinNotBeRepetitive,
      pinNotBeSequential,
      orderIsNotEligibleWLSReason,
      smbOnlineOrderValue,
      mssDefect
    },
    modalForm: { fieldRequiredMessage }
  } = translations;

  const {
    formStep: {
      businessRegularMedium: businessRegularMediumEnglish,
      subscribers16Plus: subscribers16PlusEnglish
    }
  } = EN;

  const {
    formStep: {
      businessRegularMedium: businessRegularMediumFrench,
      subscribers16Plus: subscribers16PlusFrench
    }
  } = FR;
  const {
    formStep: { directorApprovedSubmissions, directorApprovalDocRequired }
  } = locale === 'en-US' ? EN : FR;

  const {
    fields: {
      name: formStepName,
      backendKey: formStepBackendKey,
      image,
      formStepFields,
      formSummary,
      modalForms
    }
  } = stepData;

  const [isLoading, setIsLoading] = useState(true);
  const [movingToStep2, setMovingToStep2] = useState(false);
  const [isFormTouched, setIsFormTouched] = useState(false);
  const [shouldHideSubmit, setShouldHideSubmit] = useState(false);
  const [formFields, setFormFields] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [sections, setSections] = useState([]);
  const [dueNow, setDueNow] = useState(0);
  const [dueMonthly, setDueMonthly] = useState(0);
  const [fieldsWithValue, setFieldsWithValue] = useState();
  const [modalData, setModalData] = useState({
    title: '',
    body: '',
    confirmText: confirmButtonLabel,
    cancelText: cancelButtinLabel,
    open: false
  });
  const formStepRef = createRef();

  const { role } = (typeof profile !== 'undefined' && profile) || {};
  const channelWLS = profile.channel === undefined ? '' : profile.channel;
  const isChannelSevenX = channelWLS && channelWLS.name === sevenX;

  const getDefaultValue = (key, value) => {
    if (isEditing && orderData) return orderData[key];
    return value || '';
  };

  const normalizedFields = (data, initFields) => {
    let result = initFields;

    if (data) {
      data.forEach(item => {
        const { sys, fields } = item;
        const {
          name,
          type,
          required,
          value,
          minValue,
          maxValue,
          minLength,
          maxLength,
          price,
          monthlyPayment,
          options,
          tooltip,
          noteAppearsBelowField,
          customFieldErrorMessage
        } = fields;
        const {
          contentType: {
            sys: { id }
          }
        } = sys;
        const key = name;
        const ref = createRef();

        if (id === formFieldsGroup) {
          result = normalizedFields(fields.fields, result);
        } else if (id === formSection) {
          result = normalizedFields(fields.formFields, result);
        } else if (id === userDetailsKey) {
          result = normalizedFields(fields.formStepFields, result);
        } else if (id === repeatedFormKey) {
          const formObjectKeys = fields.formFields.reduce(
            (acc, { fields: { name: formNameKey, value: defaultValue } }) => {
              acc[formNameKey] = defaultValue;
              return acc;
            },
            {}
          );
          result[fields.key] = [formObjectKeys];
        } else if (!Object.prototype.hasOwnProperty.call(result, key)) {
          let defaultValue = getDefaultValue(key, value);
          let updatedMonthlyPayment = monthlyPayment;
          let updatedPrice = price;

          if (['Select', 'Radio'].includes(type)) {
            if (options && defaultValue) {
              const currentOption = options.find(
                o => o.fields.value === defaultValue
              );

              if (typeof currentOption !== 'undefined') {
                updatedPrice = currentOption.fields.price;
                updatedMonthlyPayment = currentOption.fields.monthlyPayment;
              }
            }
          }

          if (type === typeMultiCheckbox) {
            if (defaultValue && defaultValue.length > 0 && options) {
              const updateDefaultValue =
                typeof defaultValue === 'string'
                  ? defaultValue.split(',')
                  : defaultValue;
              const mappedValues = updateDefaultValue.reduce(
                (ac, a) => ({ ...ac, [a]: true }),
                {}
              );
              updatedPrice = options.reduce(
                (ac, a) =>
                  ac + ((mappedValues[a.fields.value] && a.fields.price) || 0),
                0
              );
              updatedMonthlyPayment = options.reduce(
                (ac, a) =>
                  ac +
                  ((mappedValues[a.fields.value] && a.fields.monthlyPayment) ||
                    0),
                0
              );
            }
          }

          /**
           * Condition to select default activation lagnguage
           * based on the curren locale
           */
          if (key === fieldActivationLanguage) {
            const currentLocale = getPathVariables(window.location.pathname)[0];
            defaultValue =
              currentLocale === localeFr ? valueFrench : valueEnglish;
          }

          result[key] = {
            name,
            ref,
            type,
            value: defaultValue || value,
            initPrice: updatedPrice || 0,
            price: updatedPrice || 0,
            initMonthlyPayment: updatedMonthlyPayment || 0,
            monthlyPayment: updatedMonthlyPayment || 0,
            minValue,
            maxValue,
            minLength,
            maxLength,
            isRequired: required || false,
            isVisible: true,
            options,
            tooltip,
            noteAppearsBelowField,
            customFieldErrorMessage
          };

          if (type === 'Checkbox') {
            result[key].checked = defaultValue;
          }

          if (
            type === 'PlusMinusInput' &&
            defaultValue === undefined &&
            value
          ) {
            result[key].value = value;
          }
        }
      });
    }

    return result;
  };

  const formSections = formStepFields.filter(({ sys }) => {
    const {
      contentType: {
        sys: { id }
      }
    } = sys;

    return id === formSection;
  });

  const getHiddenSections = fields => {
    const hiddenSections = [];

    formSections.forEach(section => {
      const {
        fields: { name: sectionName }
      } = section;
      if (
        !isRelatedFieldExisted(section.fields, fields, orderData, isFormTouched)
      ) {
        hiddenSections.push(sectionName);
      }
    });

    return hiddenSections;
  };

  const updateSections = updatedSections => {
    let newSections = [...formSections];
    updatedSections.forEach(item => {
      newSections = newSections.filter(section => section.fields.name !== item);
    });
    setSections(newSections);
  };

  useEffect(() => {
    if (
      (!isEditing && formStepFields) ||
      (isEditing && orderData && orderData.id)
    ) {
      const updatedFields = normalizedFields(formStepFields, formFields);
      setFormFields(updatedFields);
      updateSections(getHiddenSections(updatedFields));
      if (movingToStep2) {
        setMovingToStep2(false);
        if (formStepBackendKey === BACKEND_KEYS.productInformation) {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
      setIsFormTouched(false);
      if (isChannelSevenX && step === 6) {
        setShouldHideSubmit(true);
      }
      if (formStepRef && formStepRef.current)
        formStepRef.current.scrollTo(0, 0);
    }
  }, [formStepFields, orderData, locale]);

  const sectionIsVisible = name =>
    typeof sections.find(item => item.fields.name === name) !== 'undefined';

  const getRepeatedFormErrors = (contentfulFields, formValues) => {
    const fields = contentfulFields.filter(
      ({ fields: content }) => content.required || content.fieldValidation
    );
    return formValues.filter(formValue => {
      let filteredValues = fields.filter(
        ({ fields: { name: formKeyValue } }, index) => {
          return (
            !formValue[formKeyValue] || fields[index].fields.fieldValidation
          );
        }
      );

      const removeValidationErrors =
        filteredValues &&
        filteredValues.filter(item => {
          if (item.fields.fieldValidation) {
            if (
              item.fields.fieldValidation.fields.logic &&
              item.fields.fieldValidation.fields.logic === 'regex'
            ) {
              const regex = new RegExp(
                item.fields.fieldValidation.fields.value
              );
              if (
                !regex.test(
                  formFields.emergencyContactDetails[0][item.fields.name]
                )
              ) {
                return item;
              }
              if (
                formFields.emergencyContactDetails[0][item.fields.name].length >
                item.fields.maxLength
              ) {
                return item;
              }
            }
          }
          return null;
        });
      filteredValues = removeValidationErrors;
      return filteredValues.length > 0;
    });
  };

  const getAccumulatedFilesSize = files => {
    const keys = Object.keys(files);
    let size = 0;
    // eslint-disable-next-line no-unused-expressions
    keys.length > 0 &&
      keys.forEach(key => {
        if (files[key]) {
          const [file] = Object.keys(files[key]);
          if (files[key][file] && files[key][file].size) {
            size += files[key][file].size;
          }
        }
      });
    return size;
  };

  const getErrors = (data, errors) => {
    scrollToErrors(errors);
    let result = errors;
    if (!data) return result;
    data.forEach(({ sys, fields }) => {
      const {
        contentType: {
          sys: { id }
        }
      } = sys;
      const { name: key, type, customFieldErrorMessage } = fields;
      const {
        value,
        minValue,
        maxValue,
        isRequired,
        isVisible,
        ref,
        minLength,
        maxLength
      } =
        formFields &&
        Object.prototype.hasOwnProperty.call(formFields, key) &&
        formFields[key];
      const { files } = formFields;

      if (
        id === formFieldsGroup &&
        isRelatedFieldExisted(fields, formFields, orderData, isFormTouched)
      ) {
        result = getErrors(fields.fields, result);
      } else if (id === formSection && sectionIsVisible(key)) {
        result = getErrors(fields.formFields, result);
      } else if (id === userDetailsKey) {
        result = getErrors(fields.formStepFields, result);
      } else if (id === repeatedFormKey) {
        const repeatedFormErrors = getRepeatedFormErrors(
          fields.formFields,
          formFields[fields.key]
        );
        if (repeatedFormErrors.length) {
          result[fields.key] = repeatedFormErrors;
        } else {
          delete result[fields.key];
        }
      } else if (isVisible) {
        if (isRequired) {
          let fieldValue = value;
          if (type === typeMultiCheckbox) {
            const multiCheckboxValue = getFieldValue(key, formFields);
            fieldValue = multiCheckboxValue && multiCheckboxValue.length > 0;
          }
          if (
            !fieldValue &&
            isRelatedFieldExisted(fields, formFields, orderData, isFormTouched)
          ) {
            if (!(type === typeCheckbox && formFields[key].checked)) {
              result[key] = {
                text: customFieldErrorMessage || fieldRequiredMessage,
                ref
              };
            } else {
              delete result[key];
            }
          } else {
            delete result[key];
          }
        }
        if (typeof minValue !== 'undefined' && parseFloat(value) < minValue) {
          result[key] = {
            text: msgDisplay(minValue, minValueErrorMessage),
            ref
          };
        }
        if (typeof maxValue !== 'undefined' && parseFloat(value) > maxValue) {
          result[key] = {
            text: msgDisplay(maxValue, maxValueErrorMessage),
            ref
          };
        }
        if (minLength && value && value.length < minLength) {
          result[key] = {
            text: msgDisplay(minLength, minLengthErrorMessage),
            ref
          };
        }
        if (maxLength && value && value.length > maxLength) {
          result[key] = {
            text: msgDisplay(maxLength, maxLengthErrorMessage),
            ref
          };
        }
        if (type === inputTypeFile && files) {
          if (getAccumulatedFilesSize(files) > maxUploadSizeValueWLS) {
            result[keyFileSizeExceeded] = {
              text: maxUploadSizeErrorMessageWLS,
              ref
            };
          } else {
            delete result[keyFileSizeExceeded];
          }
        }
        //Adding logic to show errors on no file selection
        // if (
        //   formFields &&
        //   formFields.wirelessAdditionalDocumentsOne &&
        //   !formFields.wirelessAdditionalDocumentsOne.value &&
        //   step == 5 &&
        //   formFields.wirelessAdditionalDocumentsOne.isRequired == true
        // ) {
        //   result[keyDirectorApprovalRequired] = {
        //     text: directorApprovalDocRequired,
        //     ref
        //   };
        // } else {
        //   delete result[keyDirectorApprovalRequired];
        // }
        const channelName = profile.channel ? profile.channel.name : null;
        const areSubscribers16Plus =
          orderData.orderNotEligibleforMssReason &&
          (orderData.orderNotEligibleforMssReason.includes(
            subscribers16PlusEnglish
          ) ||
            orderData.orderNotEligibleforMssReason.includes(
              subscribers16PlusFrench
            ));
        if (
          key === accountType &&
          areSubscribers16Plus &&
          ![businessRegularMediumEnglish, businessRegularMediumFrench].includes(
            formFields.accountType.value
          ) &&
          !!channelWLS &&
          !WLSRestrictedChannelsForOrderCreation.includes(channelName) &&
          +orderData.numberOfSubscribers < 15
        ) {
          result[key] = {
            text:
              'You must enter number of subscribers greater than 15 to continue',
            ref
          };
        }
        if (key === pinCode && !result[key] && value) {
          // not start with zero
          if (value.indexOf(0) === 0) {
            result[key] = {
              text: msgDisplay(pinCode, pinNotStartWithZero),
              ref
            };
          } else {
            // not be repetitive (ex. 0000, 1111, 9999)
            const isRepetitive = value
              .split('')
              .filter(item => item !== value[0]);
            if (!isRepetitive.length) {
              result[key] = {
                text: msgDisplay(pinCode, pinNotBeRepetitive),
                ref
              };
            } else {
              // not be sequential (ex. 1234, 5678)
              const pinDigits = value.split('').map(item => Number(item));
              let isSequential = true;
              let i = 1;
              while (i < pinDigits.length && isSequential) {
                if (pinDigits[i] - pinDigits[i - 1] !== 1) isSequential = false;
                i += 1;
              }
              if (isSequential) {
                result[key] = {
                  text: msgDisplay(pinCode, pinNotBeSequential),
                  ref
                };
              }
            }
          }
        }
        if (fields.fieldValidation && fields.fieldValidation.fields) {
          if (
            typeof fields.appearsAfterField === 'undefined' ||
            (typeof fields.appearsAfterField !== 'undefined' &&
              isRelatedFieldExisted(
                fields,
                formFields,
                orderData,
                isFormTouched
              ))
          ) {
            const {
              errorMessage,
              logic,
              value: expectedValue
            } = fields.fieldValidation.fields;
            let hasError = false;
            switch (logic) {
              case 'equal':
                // eslint-disable-next-line eqeqeq
                hasError = !expectedValue.split('|').includes(value);
                break;
              case 'regex':
                {
                  const regexLogic = new RegExp(expectedValue);
                  hasError = !regexLogic.test(value);
                }
                break;
              case 'gt':
                hasError = parseInt(value, 10) < parseInt(expectedValue, 10);
                break;
              case 'gte':
                hasError = parseInt(value, 10) <= parseInt(expectedValue, 10);
                break;
              case 'lt':
                hasError = parseInt(value, 10) < parseInt(expectedValue, 10);
                break;
              default:
            }
            if (hasError) result[key] = { text: errorMessage, ref };
            if ((!isRequired && !value) || (!isRequired && !hasError))
              delete result[key];
          }
        }
      }
    });

    return result;
  };

  const saveAndExit = () => {
    const fields = getFormData(formFields);
    const duePrices = {
      dueMonthly,
      dueNow
    };
    if (fields[fieldKeyAddress]) {
      const keyAddress = [];
      keyAddress.push(fields[fieldKeyAddress]);
      fields.keyServiceAddresses = keyAddress;
    }
    if (Object.entries(fields).length) {
      onSaveAndExit({ ...fields, ...duePrices });
    }
  };

  const prevStep = e => {
    e.preventDefault();
    setShouldHideSubmit(false);
    setFormErrors({});
    setIsLoading(true);
    updateStep(step - 1);
    history.push({
      pathname: `/${locale}/${categoryWireless}/${wirelessOrderForm}`,
      search: `?orderId=${orderData.id}&step=${step - 1}&isEditing=true`
    });
  };

  const nextStep = e => {
    e.preventDefault();
    const errors = getErrors(formStepFields, { ...formErrors });
    setFormErrors(errors);
    if (Object.entries(errors).length === 0) {
      const fields = getFormData(formFields);
      onFormSubmit({ ...fields }, step === steps.length);
    } else {
      const firstError = errors[Object.keys(errors)[0]];
      const { ref } = firstError;
      if (ref && ref.current) ref.current.focus();
    }
  };

  const isFieldCalculated = (type, value, checked, price) => {
    switch (type) {
      case 'Radio':
        return ((value === yes || value !== undefined) && price) || 0;
      case 'Checkbox':
        return (checked && price) || 0;
      default:
        return (value && price) || 0;
    }
  };

  const updateTotals = (name, field) => {
    const { value, checked, type, price, monthlyPayment, isVisible } = field;

    if (!isVisible) return;

    let oldQuantity;
    let newQuantity;
    let oldPrice;
    let newPrice;

    if (type === 'Number') {
      oldQuantity = (formFields[name] && formFields[name].value) || 0;
      newQuantity = value ? Number(value) : 0;
      if (price > 0) {
        oldPrice = price * oldQuantity;
        newPrice = price * newQuantity;
        setDueNow(dueNow - oldPrice + newPrice);
      }
      if (monthlyPayment > 0) {
        oldPrice = monthlyPayment * oldQuantity;
        newPrice = monthlyPayment * newQuantity;
        setDueMonthly(dueMonthly - oldPrice + newPrice);
      }
    } else if (type === 'Checkbox') {
      oldQuantity = formFields[name] && formFields[name].checked ? 1 : 0;
      newQuantity = checked ? 1 : 0;
      if (price) {
        oldPrice = price * oldQuantity;
        newPrice = price * newQuantity;
        setDueNow(dueNow - oldPrice + newPrice);
      }
      if (monthlyPayment) {
        oldPrice = monthlyPayment * oldQuantity;
        newPrice = monthlyPayment * newQuantity;
        setDueMonthly(dueMonthly - oldPrice + newPrice);
      }
    } else {
      oldQuantity = formFields[name] && formFields[name].value ? 1 : 0;
      newQuantity = value ? 1 : 0;

      if (isFieldCalculated(type, value, checked, price)) {
        oldPrice = price * oldQuantity;
        newPrice = price * newQuantity;
        setDueNow(dueNow - oldPrice + newPrice);
      }
      if (isFieldCalculated(type, value, checked, monthlyPayment)) {
        oldPrice = monthlyPayment * oldQuantity;
        newPrice = monthlyPayment * newQuantity;
        setDueMonthly(dueMonthly - oldPrice + newPrice);
      }
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [step]);

  // Show footer only on landing page (not the form steps).
  useEffect(() => {
    if (formName === 'Wireless_Online_Form') {
      document.getElementById('footer').style.display = 'none';
    } else {
      document.getElementById('footer').style.display = 'block';
    }
  }, [formName]);

  useEffect(() => {
    if (isEditing && orderData && orderData.id) {
      const updatedFields = normalizedFields(formStepFields, formFields);
      setFormFields(updatedFields);
      if (orderData.dueMonthly || orderData.dueNow) {
        setDueMonthly(orderData.dueMonthly);
        setDueNow(orderData.dueNow);
      }
    }
  }, [orderData, formStepFields]);

  useEffect(() => {
    setDueMonthly(dueMonthly);
    setDueNow(dueNow);
  }, [step]);

  const resetFormFields = fields => {
    const updatedFields = Object.keys(fields).reduce((acc, fieldKey) => {
      const currentFormField = findField(formStepFields, fieldKey);
      //If field type is array, then it'll be ignored with the below logic
      if (_.isArray(fields[fieldKey])) {
        return { ...acc, [fieldKey]: fields[fieldKey] };
      }
      const isVisible = isRelatedFieldExisted(
        _.get(currentFormField, 'fields', {}),
        fields,
        orderData,
        true
      );

      if (!isVisible)
        return { ...acc, [fieldKey]: { ...fields[fieldKey], value: '' } };
      return { ...acc, [fieldKey]: { ...fields[fieldKey] } };
    }, {});
    return updatedFields;
  };

  const handleFormField = (
    { name, value, checked, files },
    ref,
    isFieldModified
  ) => {
    const fields = { ...formFields };

    if (
      isChannelSevenX &&
      isFieldModified &&
      name === fieldWirlessConfirmationCustomer
    ) {
      setShouldHideSubmit(false);
    }
    if (isFieldModified && !isFormTouched) {
      setIsFormTouched(true);
    }
    fields[name] = { ...fields[name], value, checked, isVisible: true };

    // Form sections visibility can be related to fields and values
    updateSections(getHiddenSections(fields));

    if (files && files.length) {
      const [file] = files;
      const checkFileExists = (filesToCheck, fileKey) =>
        filesToCheck.find(fileDetails => fileDetails[fileKey]);
      const updateFile = (fileList, fileKey, updatedFile) => {
        const updatedFileList = fileList.map(fileDetails => {
          if (fileDetails[fileKey]) {
            // eslint-disable-next-line no-param-reassign
            fileDetails[name] = updatedFile;
          }
          return fileDetails;
        });
        return updatedFileList;
      };
      if (
        fields.files &&
        fields.files.length &&
        !checkFileExists(fields.files, name)
      ) {
        fields.files.push({ [name]: file });
      } else if (
        fields.files &&
        fields.files.length &&
        checkFileExists(fields.files, name)
      ) {
        const updatedFileList = updateFile(fields.files, name, file);
        fields.files = updatedFileList;
      } else {
        fields.files = [{ [name]: file }];
      }
      fields[name].value = file.name;
    } else {
      // Check if cancel button is clicked while uloading file then remove selected file
      // from fields.files array
      if (name === wirelessAdditionalDocumentsOne && fields.files[0]) {
        fields.files.splice(0, 1);
      }
      if (name === wirelessAdditionalDocumentsTwo && fields.files[1]) {
        if (fields.files.length < 2) {
          fields.files.splice(0, 1);
        } else {
          fields.files.splice(1, 1);
        }
      }
    }
    if (name === smbIndirectChannelSalesRep) {
      setOrderData({
        ...orderData,
        [name]: value
      });
    }
    setFormFields(resetFormFields(fields));
  };

  useEffect(() => {
    const formFieldsKeys = Object.keys(formFields);
    if (formFieldsKeys.length && typeof fieldsWithValue === 'undefined') {
      const initFieldsWithValue = [];
      formFieldsKeys.forEach(name => {
        const { value } = formFields[name];
        if (value) {
          initFieldsWithValue.push({ name, value });
          updateTotals(name, formFields[name]);
        }
      });
      setFieldsWithValue(initFieldsWithValue);
    }
  }, [Object.keys(formFields).length]);

  const renderFormSummary = formSummaryGroup => {
    let summaryData = orderData;
    // if (step === 1) {
    //   summaryData = { ...profile, ...summaryData };
    // }
    return <FormSummaryGroup data={formSummaryGroup} orderData={summaryData} />;
  };

  const renderFormFields = data =>
    data &&
    data.length > 0 &&
    data.map(({ sys, fields }, indexRoot) => {
      const {
        contentType: {
          sys: { id }
        },
        id: sysId
      } = sys;
      const disableOptions = (options, targets, value) => {
        const updatedOptions = [...options];
        targets.forEach(target => {
          updatedOptions.forEach(option => {
            if (option.fields.value === target) {
              option.fields.disabledOption = value;
            }
          });
        });
        return updatedOptions;
      };
      const { name: fieldName, title, expiredDate } = fields;
      if (
        fieldName === wirelessAdditionalDocumentsOne ||
        fieldName === wirelessAdditionalDocumentsComments
      ) {
        if (!(orderData.reasonForSubmission === mssDefects && orderData.mssDefectTeam === smbSales)) {
          if(formFields.wirelessAdditionalDocumentsOne && formFields.wirelessAdditionalDocumentsComments){
          formFields.wirelessAdditionalDocumentsOne.isRequired = false;
          formFields.wirelessAdditionalDocumentsComments.isRequired = false;
          fields.required = false;
          }}
      }
      if (fieldName === errorInMSS || fieldName === description) {
        if (orderData.reasonForSubmission === mssDefects) {
          if (orderData.mssDefectTeam !== smbSales) {
            return null;
          }
        }
      }
      const getUpdatedOptions = (options, valuesToFilter) => {
        return options.filter(
          option => !valuesToFilter.includes(option.fields.value)
        );
      };

      const isDevicesOnly =
        orderData.orderNotEligibleforMssReason &&
        (orderData.orderNotEligibleforMssReason.includes(DevicesOnlyEnglish) ||
          orderData.orderNotEligibleforMssReason.includes(DevicesOnlyFrench));
      const isAccessoriesOnly =
        orderData.orderNotEligibleforMssReason &&
        (orderData.orderNotEligibleforMssReason.includes(
          AccessoriesOnlyEnglish
        ) ||
          orderData.orderNotEligibleforMssReason.includes(
            AccessoriesOnlyFrench
          ));
      const areSubscribers16Plus =
        orderData.orderNotEligibleforMssReason &&
        (orderData.orderNotEligibleforMssReason.includes(
          subscribers16PlusEnglish
        ) ||
          orderData.orderNotEligibleforMssReason.includes(
            subscribers16PlusFrench
          ));

      let selectOptions;
      let directorApprovalWebform;
      if (step === 5) {
        directorApprovalWebform =
          orderData &&
          orderData.orderNotEligibleforMssReason &&
          orderData.orderNotEligibleforMssReason.includes(
            directorApprovedSubmissions
          );
      }
      const channelName = profile.channel ? profile.channel.name : null;
      const restrictedChannel = WLSRestrictedChannelsForOrderCreation.includes(
        channelName
      );
      let error;
      // fieldName === wirelessAdditionalDocumentsOne ||
      // fieldName === wirelessAdditionalDocumentsTwo
      //   ? formErrors[keyFileSizeExceeded]
      //   : formErrors[fieldName];
      if (
        (orderData.requiresDirectorsApproval == 'Yes' ||
          orderData.requiresDirectorsApproval == 'Oui' ||
          directorApprovalWebform) &&
        !restrictedChannel &&
        (fieldName === wirelessAdditionalDocumentsOne ||
          fieldName === wirelessAdditionalDocumentsTwo) &&
        formFields &&
        formFields.wirelessAdditionalDocumentsOne &&
        !formFields.wirelessAdditionalDocumentsOne.value &&
        !formFields.wirelessAdditionalDocumentsTwo.value
      ) {
        error = formErrors[keyDirectorApprovalRequired];
      } else if (
        (fieldName === wirelessAdditionalDocumentsOne && formFields.wirelessAdditionalDocumentsOne &&
          formFields.wirelessAdditionalDocumentsOne.value) ||
        (fieldName === wirelessAdditionalDocumentsTwo && formFields.wirelessAdditionalDocumentsTwo &&
          formFields.wirelessAdditionalDocumentsTwo.value)
      ) {
        error = formErrors[keyFileSizeExceeded];
      } else {
        error = formErrors[fieldName];
      }

      // Add any updates to appearAfterFields logic here
      if (step === 2 && fieldName === numberOfSubscribers && isChannelSevenX) {
        fields.appearsAfterField = null;
      }

      const key = `FormField${fieldName}${indexRoot}${sysId}`;
      let result;
      let fieldNote;

      if (expiredDate && new Date(expiredDate) < new Date()) return null;
      if (!isRelatedFieldExisted(fields, formFields, orderData, isFormTouched))
        return null;

      // if (
      //   formFields &&
      //   formFields.wirelessAdditionalDocumentsOne &&
      //   orderData &&
      //   orderData.requiresDirectorsApproval === 'Yes'
      // ) {
      // }
      //
      // Below logic will make attachments mandatory

      if (
        formFields.wirelessAdditionalDocumentsOne &&
        (orderData.requiresDirectorsApproval === 'Yes' ||
          orderData.requiresDirectorsApproval === 'Oui' ||
          directorApprovalWebform) &&
        !restrictedChannel
      ) {
        formFields.wirelessAdditionalDocumentsOne.isRequired = true;
      }

      const fieldValue = getFieldValue(fieldName, formFields);
      if (id === formFieldsGroup) {
        const groupIsVisible = fields.fields.find(item => {
          const { fields: itemFields } = item;
          if (!formFields[itemFields.name]) return null;
          const { value, isVisible } = formFields[itemFields.name];
          return (
            (value && isVisible) ||
            isRelatedFieldExisted(
              itemFields,
              formFields,
              orderData,
              isFormTouched
            )
          );
        });

        if (typeof groupIsVisible !== 'undefined') {
          if (title === creditCheck) {
            if (
              !newWirelessActivation.includes(orderData.installationTypeWLS) ||
              isChannelSevenX // SOF-2171
            ) {
              formFields.creditCheckPassMSS.isVisible = false;
              return null;
            }
          }
          if (title === otherAuthorizedContact) {
            if (
              !addOnAndNewWireless.includes(orderData.installationTypeWLS) ||
              isChannelSevenX // SOF-2171
            ) {
              formFields.addAuthorisedContact.isVisible = false;
              return null;
            }
          }
          if (title === subscriptionToEbill) {
            if (!addOnAndNewWireless.includes(orderData.installationTypeWLS)) {
              formFields.signupForEBill.isVisible = false;
              return null;
            }
          }
          result = (
            <GroupWrapper key={key}>
              {title && <GroupTitle>{title}</GroupTitle>}
              {renderFormFields(fields.fields)}
            </GroupWrapper>
          );
        }
      } else if (id === formSectionTitle) {
        const { title: sectionTitle } = fields;
        return <Heading level="h3">{sectionTitle}</Heading>;
      } else if (id === formSection) {
        if (
          step === 6 ||
          (isDevicesOnly && step === 5) ||
          (isAccessoriesOnly && step === 5)
        ) {
          result = (
            <OrderSummary
              stepData={isChannelSevenX ? steps.slice(1) : steps}
              orderData={orderData}
            />
          );
        } else {
          const { note, formSummaryGroup } = fields;

          const renderNote = note && note.content && (
            <Note data={note} type="richText" />
          );

          const { name } = role || {};
          result = sectionIsVisible(fieldName) && (
            <ExpandCollapse.Panel
              key={key}
              id={fieldName}
              header={
                formStepBackendKey === stepKeyMain && locale !== localeFrench
                  ? `${roleLabels[name]} ${title}`
                  : `${title}`
              }
            >
              <>
                {renderNote && renderNote}
                {renderFormFields(fields.formFields)}
                {/* {formSummaryGroup
                  ? renderFormSummary(formSummaryGroup)
                  : renderFormFields(fields.formFields)} */}
              </>
            </ExpandCollapse.Panel>
          );
        }
      } else if (id === userDetailsKey) {
        let disabled = false;
        let isSameAsCheckboxChecked = false;
        if (isChannelSevenX) {
          if (fields.backendKey === 'serviceOrShippingAddress') {
            fields.name = fields.name.replace('Service /', '');
          }
          if (fields.backendKey === 'billingAddress') {
            disabled = true;
            isSameAsCheckboxChecked = true;
            fields.sameAsCheckBox.fields.label = fields.sameAsCheckBox.fields.label.replace(
              'Service/',
              ''
            );
          }
        }
        if (
          orderData.installationTypeWLS &&
          newWirelessActivation.includes(orderData.installationTypeWLS)
        ) {
          if (fields.backendKey === 'billingAddress') {
            disabled = true;
            isSameAsCheckboxChecked = true;
          }
        }
        result = (
          <UserDetailsForm
            key={key}
            data={fields}
            setFormFields={setFormFields}
            orderData={orderData}
            formErrors={formErrors}
            formFields={formFields}
            isEditing={isEditing}
            isFormTouched={isFormTouched}
            setIsFormTouched={setIsFormTouched}
            disabled={disabled}
            isSameAsCheckboxChecked={isSameAsCheckboxChecked}
          />
        );
      } else if (id === repeatedFormKey) {
        result = (
          <RepeatedForm
            key={key}
            data={fields}
            setFormFields={setFormFields}
            orderData={orderData}
            formErrors={formErrors}
            formFields={formFields}
            isEditing={isEditing}
            isFormTouched={isFormTouched}
            setIsFormTouched={setIsFormTouched}
          />
        );
      } else if (id === 'note') {
        const dataObj = {
          type: 'TextNote',
          note: fields.content,
          isShowNoteBackground: true
        };
        result = <FormField data={dataObj} />;
      } else {
        const fieldButtonProps = fields.type === 'Button' ? { modalForms } : {};
        let ref;
        let isDisabled;
        if (formFields[fieldName]) {
          ({ ref, isDisabled } = formFields[fieldName]);
        }

        let newFields = [];
        let update = false;
        const channelName = profile.channel ? profile.channel.name : null;
        if (
          step === 1 &&
          fields.name === reasonForSubmission &&
          WLSRestrictedChannelsForOrderCreation.includes(channelName)
        ) {
          fields.options = fields.options.filter(x =>
            WLSRestrictedReasonForSubmissionForChannels.includes(x.fields.value)
          );
        }
        if (
          step === 1 &&
          fields.name === orderNotEligibleforMssReason &&
          WLSRestrictedChannelsForOrderCreation.includes(channelName)
        ) {
          fields.options = fields.options.filter(x =>
            WLSRestrictedOrderIsNotEligibleForMSSForChannels.includes(
              x.fields.value
            )
          );
        }
        // SOF-2135
        if (step === 1 && fieldName === mssDefectTeam) {
          if (WLSRestrictedChannelsForOrderCreation.includes(channelName)) {
            fields.options = fields.options.filter(
              x => x.fields.value === BCX_CARE
            );
          }
        }
        if (step === 1 && formFields[reasonForSubmission]) {
          // SOF-1655
          if (
            formFields[reasonForSubmission].value ===
              reasonForSubOptionsEN[1] ||
            formFields[reasonForSubmission].value ===
              reasonForSubOptionsEN[2] ||
            formFields[reasonForSubmission].value ===
              reasonForSubOptionsEN[3] ||
            formFields[reasonForSubmission].value ===
              reasonForSubOptionsFR[1] ||
            formFields[reasonForSubmission].value ===
              reasonForSubOptionsFR[2] ||
            formFields[reasonForSubmission].value === reasonForSubOptionsFR[3]
          ) {
            formFields[mssDefectTeam].value = undefined;
            formFields[spocTicketNumber].value = undefined;
            formFields[channelTicketNumber].value = undefined;
          }
          if (formFields[mssDefectTeam].value === SMB_Sales) {
            formFields[spocTicketNumber].value = undefined;
          }
          if (formFields[mssDefectTeam].value === BCX_CARE) {
            formFields[channelTicketNumber].value = undefined;
          }
          // SOF-1669
          if (step === 1 && formFields[reasonForSubmission]) {
            // Clear MSS order requiring resubmission releated fields on uncheck
            const orderRequiresResubmisssionVariants = [
              reasonForSubOptionsEN[1],
              reasonForSubOptionsFR[1]
            ];
            const orderRequiresResubmisssionChecked = orderRequiresResubmisssionVariants.includes(
              formFields[reasonForSubmission].value
            );
            if (!orderRequiresResubmisssionChecked) {
              const orderRequiresResubmisssionRelatedFields = [
                fieldIssueSummary,
                fieldExpectedBehavior,
                fieldCurrentBehaviour,
                fieldOriginalMssOrderNumber
              ];
              // orderRequiresResubmisssionRelatedFields.forEach(fieldName => {
              //   delete formFields[fieldName];
              // });
            }

            // Clear order not eligible related fields on uncheck
            const orderNotEligibleVariants = [
              reasonForSubOptionsEN[2],
              reasonForSubOptionsFR[2]
            ];
            const orderNotEligibleChecked = orderNotEligibleVariants.includes(
              formFields[reasonForSubmission].value
            );
            // if (!orderNotEligibleChecked) {
            //   delete formFields[orderNotEligibleforMssReason];
            // }

            // Clear expired offers related fields on uncheck
            const expiredOfferVariants = [
              reasonForSubOptionsEN[3],
              reasonForSubOptionsFR[3]
            ];
            const expiredOfferChecked = expiredOfferVariants.includes(
              formFields[reasonForSubmission].value
            );
            if (!expiredOfferChecked) {
              const expiredOffersRelatedFields = [
                fieldPromoNameThatExpired,
                fieldDatePromoExpired,
                fieldScreenshotOfSavedOrderInMSS,
                files
              ];
              // expiredOffersRelatedFields.forEach(fieldName => {
              //   delete formFields[fieldName];
              // });
            }
          }

          // SOF-1627
          // if (fieldName === reasonForSubmission && fieldValue === mssDefect) {
          //   delete formFields[orderNotEligibleforMssReason];
          // }
          if (
            fieldName === orderNotEligibleforMssReason &&
            fieldValue &&
            (fieldValue.includes(DevicesOnlyEnglish) ||
              fieldValue.includes(DevicesOnlyFrench))
          ) {
            formFields.orderNotEligibleforMssReason.value = [
              fieldValue.includes(DevicesOnlyEnglish)
                ? DevicesOnlyEnglish
                : DevicesOnlyFrench
            ];
            newFields = fields.options.filter(
              item =>
                item.fields.value === DevicesOnlyEnglish ||
                item.fields.value === DevicesOnlyFrench
            );
            update = true;
          }

          if (
            fieldName === orderNotEligibleforMssReason &&
            fieldValue &&
            (fieldValue.includes(AccessoriesOnlyEnglish) ||
              fieldValue.includes(AccessoriesOnlyFrench))
          ) {
            formFields.orderNotEligibleforMssReason.value = [
              fieldValue.includes(AccessoriesOnlyEnglish)
                ? AccessoriesOnlyEnglish
                : AccessoriesOnlyFrench
            ];
            newFields = fields.options.filter(
              item =>
                item.fields.value === AccessoriesOnlyEnglish ||
                item.fields.value === AccessoriesOnlyFrench
            );
            update = true;
          }
        }

        if (
          step === 2 &&
          !isChannelSevenX &&
          fieldName === fieldLeadID &&
          formFields[fieldLeadID]
        ) {
          formFields[fieldLeadID].isVisible = false;
          return null;
        }

        // check for step 2 and any field present in step 3. For example: provinceWLS.
        if (step === 2 && !isEmpty(formFields.provinceWLS)) {
          if (fieldName === sourceOfSaleWLS) {
            if (!inkerosEastWestChannels.includes(channelWLS.name)) {
              formFields.sourceOfSaleWLS.isVisible = false;
              return null;
            }
          }

          if (fieldName === isThisHealth) {
            if (!inkerosEastWestChannels.includes(channelWLS.name)) {
              formFields.isThisHealth.isVisible = false;
              return null;
            }
          }

          if (
            orderData.reasonForSubmission &&
            orderData.reasonForSubmission === orderIsNotEligibleWLSReason
          ) {
            if (
              orderData &&
              orderData.orderNotEligibleforMssReason &&
              orderData.orderNotEligibleforMssReason.length
            ) {
              if (isDevicesOnly || isAccessoriesOnly) {
                if (fieldName === fieldActivationLanguage) {
                  formFields.activationLanguage.isVisible = false;
                  return null;
                }
                if (fieldName === activationType) {
                  formFields.activationType.isVisible = false;
                  return null;
                }
                if (fieldName === fieldInstallationTypeWLS) {
                  formFields.installationTypeWLS.isVisible = false;
                  return null;
                }
              }
              // SOF-1722 (on hold)
              // if (areSubscribers16Plus) {
              //   formFields.numberOfSubscribers.minValue = 16;
              //   if (
              //     formErrors.numberOfSubscribers &&
              //     formErrors.numberOfSubscribers.text ===
              //       minimum16SubscribersErrorMessageDefault
              //   ) {
              //     formErrors.numberOfSubscribers.text = minimum16SubscribersErrorMessage;
              //   }
              // }
              if (fieldName === hardwarePaidAlready) {
                if (
                  orderData.orderNotEligibleforMssReason.includes(
                    smbOnlineOrderValue
                  )
                ) {
                  formFields.hardwarePaidAlready.isVisible = true;
                } else {
                  formFields.hardwarePaidAlready.isVisible = false;
                  return null;
                }
              }
              if (fieldName === omsParentOrderNumber) {
                if (
                  orderData.orderNotEligibleforMssReason.includes(
                    smbOnlineOrderValue
                  )
                ) {
                  formFields.omsParentOrderNumber.isVisible = true;
                } else {
                  formFields.omsParentOrderNumber.isVisible = false;
                  return null;
                }
              }
            }
          } else {
            if (fieldName === hardwarePaidAlready) {
              formFields.hardwarePaidAlready.isVisible = false;
              return null;
            }
            if (fieldName === omsParentOrderNumber) {
              formFields.omsParentOrderNumber.isVisible = false;
              return null;
            }
          }

          if (fieldName === activationType) {
            if (
              (newWirelessActivation.includes(
                formFields.installationTypeWLS.value
              ) ||
                addOnActivation.includes(
                  formFields.installationTypeWLS.value
                )) &&
              channelWLS !== smbOnlineOrder
            ) {
              newFields = fields.options.filter(item =>
                activationTypeListOne.includes(item.fields.value)
              );
              update = true;
            }

            if (
              (newWirelessActivation.includes(
                formFields.installationTypeWLS.value
              ) ||
                addOnActivation.includes(
                  formFields.installationTypeWLS.value
                )) &&
              channelWLS === smbOnlineOrder
            ) {
              newFields = fields.options.filter(item =>
                activationTypeListTwo.includes(item.fields.value)
              );
              update = true;
            }

            if (renewal.includes(formFields.installationTypeWLS.value)) {
              newFields = fields.options.filter(item =>
                activationTypeListThree.includes(item.fields.value)
              );
              update = true;
            }
          }

          if (
            fieldName === customerLocation &&
            (!newWirelessActivation.includes(
              formFields.installationTypeWLS.value
            ) ||
              !customerFacingActivation.includes(
                formFields.activationType.value
              ))
          ) {
            formFields.customerLocation.isVisible = false;
            return null;
          }

          if (fieldName === productSelectionWLS) {
            if (isDevicesOnly || isAccessoriesOnly) {
              newFields = fields.options.filter(item =>
                devicesOnlyProductSelection.includes(item.fields.value)
              );
              update = true;
            }
            if (
              addOnAndNewWireless.includes(formFields.installationTypeWLS.value)
            ) {
              newFields = fields.options.filter(item =>
                wireless.includes(item.fields.value)
              );
              update = true;
            }
            if (renewal.includes(formFields.installationTypeWLS.value)) {
              newFields = fields.options.filter(item =>
                renewal.includes(item.fields.value)
              );
              update = true;
            }
          }

          if (!isEmpty(orderData.provinceWLS)) {
            localStorage.setItem('provinceWLS', orderData.provinceWLS);
          }

          // SOF-2171
          if (isChannelSevenX) {
            if (fieldName === fieldInstallationTypeWLS) {
              newFields = fields.options.filter(
                item => !renewal.includes(item.fields.value)
              );
              update = true;
            }
            if (fieldName === fieldSubscriberProvince) {
              newFields = fields.options.filter(
                item => !valueQuebec.includes(item.fields.value)
              );
              update = true;
            }
            if (fieldName === activationType) {
              formFields[activationType].isVisible = false;
              return null;
            }
            if (fieldName === productSelectionWLS) {
              formFields[productSelectionWLS].isVisible = false;
              return null;
            }
          }
        }
        // check for step 3 and any field present in step 3. For example: agentNameSalesRep.
        if (step === 3 && !isEmpty(formFields.agentNameSalesRep)) {
          const {
            fullName,
            email,
            contactNumberSalesRep: contactNumber,
            contactNumber: simpleContactNumber,
            outlet,
            xid,
            salesRepId,
            salesManager,
            salesManagerEmail,
            firstName,
            lastName
          } = orderData.orderCreatedBy || {};

          if (fieldName === agentNameSalesRep)
            formFields.agentNameSalesRep.value =
              fullName || `${firstName} ${lastName}` || '';

          if (fieldName === agentEmailAddress)
            formFields.agentEmailAddress.value = email;

          if (fieldName === outletSalesRep) {
            if (
              !(
                profile.channelName === smbIndirectSalesChannel ||
                orderData.outletSalesRep
              )
            ) {
              formFields.outletSalesRep.value = outlet;
              isDisabled = true;
            }
            if (
              profile.channelName === sbsTISalesChannel &&
              orderData.reasonForSubmission === orderIsNotEligibleWLSReason &&
              orderData.orderNotEligibleforMssReason.includes(
                smbOnlineOrderValue
              )
            ) {
              formFields.outletSalesRep.value = `1100049671`;
              isDisabled = true;
            }
          }

          if (fieldName === contactNumberSalesRep)
            formFields.contactNumberSalesRep.value =
              contactNumber || simpleContactNumber || '';

          if (fieldName === tIDxIDSalesRep)
            formFields.tIDxIDSalesRep.value = xid || '';

          const lastWord = words => {
            if (words !== undefined) {
              const n = words.split(/[\s,]+/);
              return n[n.length - 1];
            }
            return undefined;
          };
          const showDropdownForChannels = lastWord(profile.channelName);
          if (fieldName === channelNameSalesRep) {
            if (showDropdownForChannels === undefined) {
              formFields.channelNameSalesRep.isVisible = false;
              return null;
            }
            if (showDropdownForChannels === 'Other') {
              formFields.channelNameSalesRep.isVisible = false;
              return null;
            }
            formFields.channelNameSalesRep.value = profile.channelName;
            isDisabled = true;
          }
          if (fieldName === smbIndirectChannelSalesRep) {
            if (showDropdownForChannels === undefined) {
              formFields.smbIndirectChannelSalesRep.isVisible = false;
              return null;
            }
            if (
              showDropdownForChannels !== 'Other' &&
              !isEmpty(formFields.channelNameSalesRep.value)
            ) {
              formFields.smbIndirectChannelSalesRep.isVisible = false;
              return null;
            }
            if (!formFields.smbIndirectChannelSalesRep.value)
              formFields.smbIndirectChannelSalesRep.value = profile.channelName;
          }
          if (fieldName === idSalesRep) {
            if (
              profile.channelName === sbsTISalesChannel &&
              orderData.reasonForSubmission === orderIsNotEligibleWLSReason &&
              orderData.orderNotEligibleforMssReason.includes(
                smbOnlineOrderValue
              )
            ) {
              isDisabled = false;
            } else {
              formFields.idSalesRep.value =
                salesRepId === null ? '' : salesRepId;
              isDisabled = true;
            }
          }

          if (fieldName === channelManagerSalesRep)
            formFields.channelManagerSalesRep.value = salesManager;

          if (fieldName === channelManagerEmailAddress)
            formFields.channelManagerEmailAddress.value = salesManagerEmail;

          if (
            [
              agentNameSalesRep,
              agentEmailAddress,
              contactNumberSalesRep,
              tIDxIDSalesRep,
              outletSalesRep,
              channelManagerSalesRep,
              channelManagerEmailAddress
            ].includes(fieldName)
          )
            isDisabled = true;
          if (
            fieldName === telusAccountNumberCustomerInformation &&
            newWirelessActivation.includes(orderData.installationTypeWLS)
          ) {
            formFields.telusAccountNumberCustomerInformation.isVisible = false;
            return null;
          }
          if (
            fieldName === tradeNameWLS &&
            orderData.installationTypeWLS === addOnActivation
          )
            return null;

          if (
            fieldName === tradeNameWLS &&
            (isDevicesOnly || isAccessoriesOnly)
          )
            return null;

          if (fieldName === pinCode && (isDevicesOnly || isAccessoriesOnly)) {
            formFields.pinCode.isVisible = false;
            return null;
          }

          if (
            fieldName === additionalCommentsNote &&
            (isDevicesOnly || isAccessoriesOnly)
          ) {
            formFields.additionalCommentsNote.isVisible = false;
            return null;
          }

          if (fieldName === creditCheck) {
            const showCreditCheck =
              addOnAndNewWireless.includes(orderData.installationTypeWLS) &&
              orderData.channelWLS === smbOnlineOrder;
            if (!showCreditCheck) {
              formFields.creditCheck.isVisible = false;
              return null;
            }
          }

          if (
            fieldName === isCustomerOwner &&
            !newWirelessActivation.includes(orderData.installationTypeWLS)
          ) {
            formFields.isCustomerOwner.isVisible = false;
            return null;
          }

          if (
            fieldName === website &&
            !newWirelessActivation.includes(orderData.installationTypeWLS)
          ) {
            formFields.website.isVisible = false;
            return null;
          }

          if (
            fieldName === addAuthorisedContact &&
            !addOnAndNewWireless.includes(orderData.installationTypeWLS)
          ) {
            formFields.addAuthorisedContact.isVisible = false;
            return null;
          }

          if (
            fieldName === fullNameWLS &&
            formFields.addAuthorisedContact.value === No
          ) {
            formFields.fullName.isVisible = false;
            return null;
          }

          if (
            fieldName === pinCode &&
            !addOnAndNewWireless.includes(orderData.installationTypeWLS)
          ) {
            formFields.pinCode.isVisible = false;
            return null;
          }

          if (
            fieldName === signupForEBill &&
            !addOnAndNewWireless.includes(orderData.installationTypeWLS)
          ) {
            formFields.signupForEBill.isVisible = false;
            return null;
          }

          if (
            fieldName === visitedShippingAddress &&
            formFields &&
            formFields.sameAs_serviceOrShippingAddress &&
            formFields.sameAs_serviceOrShippingAddress.value
          ) {
            formFields.visitedShippingAddress.isVisible = false;
            return null;
          }

          if (
            fieldName === accountType &&
            orderData.installationTypeWLS &&
            !isDevicesOnly &&
            !isAccessoriesOnly &&
            !isChannelSevenX &&
            // If webform is "16+ subscribers" then show business regular medium regardless of installation type"
            // If webform is NOT "16+ subscribers", show business regular medium only if installation type is renewal
            (areSubscribers16Plus
              ? false
              : addOnAndNewWireless.includes(orderData.installationTypeWLS))
          ) {
            newFields = fields.options.filter(
              item =>
                item.fields.value !== businessRegularMediumEnglish &&
                item.fields.value !== businessRegularMediumFrench
            );
            update = true;
          }
          if (
            fieldName === accountType &&
            areSubscribers16Plus &&
            ![
              businessRegularMediumEnglish,
              businessRegularMediumFrench
            ].includes(formFields.accountType.value) &&
            !!channelWLS &&
            !WLSRestrictedChannelsForOrderCreation.includes(channelName) &&
            +orderData.numberOfSubscribers < 15 &&
            formFields.accountType.value
          ) {
            error = {
              text:
                'You must enter number of subscribers greater than 15 to continue'
            };
          }

          // check if shipping address is exactly same as billing address
          const directorsFields = [directorsName, directorsEmail];
          if (formFields.streetAddress_serviceOrShippingAddress) {
            const compareFields = [
              'streetAddress_serviceOrShippingAddress',
              'streetAddress_billingAddress',
              'unit_serviceOrShippingAddress',
              'unit_billingAddress',
              'city_serviceOrShippingAddress',
              'city_billingAddress',
              'province_serviceOrShippingAddress',
              'province_billingAddress',
              'postalCode_serviceOrShippingAddress',
              'postalCode_billingAddress'
            ];
            const compareResult = compareFields.reduce(
              (prev, next) => {
                const res = { ...prev };
                if (!res.field) {
                  return { ...res, field: next, key: 1 };
                }
                const prevValue = formFields[prev.field].value
                  ? formFields[prev.field].value.trim()
                  : '';
                const nextValue = formFields[next].value
                  ? formFields[next].value.trim()
                  : '';
                if (res.key % 2 !== 0 && prevValue !== nextValue) {
                  res.mismatchCount = ++res.mismatchCount;
                }
                res.field = next;
                res.key++;
                return res;
              },
              { mismatchCount: 0, key: 0 }
            );

            if (
              compareResult.mismatchCount === 0 ||
              isChannelSevenX ||
              (orderData.installationTypeWLS &&
                newWirelessActivation.includes(orderData.installationTypeWLS))
            ) {
              formFields.requiresDirectorsApproval.value = false;
              formFields.requiresDirectorsApproval.checked = false;
              orderData.requiresDirectorsApproval = no;

              directorsFields.forEach(directorField => {
                formFields[directorField].isVisible = false;
                formFields[directorField].isRequired = false;
              });

              if (directorsFields.includes(fieldName)) {
                return null;
              }
            } else {
              formFields.requiresDirectorsApproval.value = true;
              formFields.requiresDirectorsApproval.checked = true;
              orderData.requiresDirectorsApproval = yes;
              directorsFields.forEach(directorField => {
                formFields[directorField].isRequired = true;
              });
            }
          } else if (directorsFields.includes(fieldName)) {
            formFields[fieldName].isVisible = false;
            formFields[fieldName].isRequired = false;
            return null;
          }
          const copyServiceAddressToBillingAddress = () => {
            formFields.streetAddress_billingAddress.value =
              formFields.streetAddress_serviceOrShippingAddress.value;

            formFields.unit_billingAddress.value =
              formFields.unit_serviceOrShippingAddress.value;

            formFields.city_billingAddress.value =
              formFields.city_serviceOrShippingAddress.value;

            formFields.province_billingAddress.value =
              formFields.province_serviceOrShippingAddress.value;

            formFields.postalCode_billingAddress.value =
              formFields.postalCode_serviceOrShippingAddress.value;
          };
          if (
            orderData.installationTypeWLS &&
            newWirelessActivation.includes(orderData.installationTypeWLS)
          )
            copyServiceAddressToBillingAddress();
          // SOF-2171
          if (isChannelSevenX) {
            copyServiceAddressToBillingAddress();
            if (fieldName === accountType) {
              if (
                newWirelessActivation.includes(orderData.installationTypeWLS)
              ) {
                newFields = fields.options.filter(
                  item =>
                    item.fields.value !== businessRegularMediumEnglish &&
                    item.fields.value !== businessRegularMediumFrench
                );
                update = true;
              } else {
                newFields = fields.options.map(item => {
                  if (
                    item.fields.value === businessRegularMediumEnglish ||
                    item.fields.value === businessRegularMediumFrench
                  ) {
                    const itemTemp = cloneDeep(item);
                    itemTemp.fields.label = `${item.fields.label} (2 years only)`;
                    itemTemp.fields.value = `${item.fields.value} (2 years only)`;
                    return itemTemp;
                  } else {
                    return item;
                  }
                });
                update = true;
              }
            }
            if (fieldName === tradeNameWLS) {
              if (addOnActivation.includes(orderData.installationTypeWLS)) {
                formFields[tradeNameWLS].isVisible = false;
                return null;
              }
            }
            if (fieldName === wlsBusinessLegalName) {
              if (addOnActivation.includes(orderData.installationTypeWLS)) {
                formFields[wlsBusinessLegalName].isVisible = false;
                return null;
              }
            }
            if (fieldName === fieldInboundOutbound) {
              formFields[fieldInboundOutbound].isVisible = false;
              return null;
            }
            if (fieldName === visitedShippingAddress) {
              formFields[visitedShippingAddress].isVisible = false;
              return null;
            }
            if (fieldName === isCustomerOwner) {
              formFields[isCustomerOwner].isVisible = false;
              return null;
            }
            if (fieldName === requiresDirectorsApproval) {
              formFields[visitedShippingAddress].isVisible = false;
              return null;
            }
            if (fieldName === directorsName) {
              formFields[directorsName].isVisible = false;
              return null;
            }
            if (fieldName === directorsEmail) {
              formFields[directorsEmail].isVisible = false;
              return null;
            }
          }
        }
        if (
          fieldName === fieldWirlessConfirmationCustomer &&
          !isChannelSevenX
        ) {
          if (formFields[fieldWirlessConfirmationCustomer]) {
            formFields[fieldWirlessConfirmationCustomer].isRequired = false;
          }
          return null;
        }
        const fieldData = {
          ...fields,
          options: selectOptions || update ? newFields : fields.options,
          ...fieldButtonProps,
          note: fieldNote || fields.note,
          ref,
          formFields,
          name: fieldName,
          value: fieldValue,
          disabled: isDisabled,
          readonly: isDisabled,
          sysId,
          onChange: (e, refV) => handleFormField(e.target, refV, true),
          onBlur: () => {}
        };

        if (
          (!isFormTouched || fieldName === requiresDirectorsApproval) &&
          fields.type === 'Checkbox'
        ) {
          fieldData.checked = fieldValue;
        }

        const valueAccountType = getFieldValue('accountType', formFields);

        if (
          !(
            isChannelSevenX &&
            newWirelessActivation.includes(orderData.installationTypeWLS) &&
            (valueAccountType === fieldBusinessRegular ||
              valueAccountType === fieldBusinessRegularFr)
          )
        ) {
          if (
            fieldName === fieldWLSIncorporationNumber ||
            fieldName === fieldWLSIncorporationDate
          ) {
            return null;
          }
        }

        if (step === 1 && fields.name === reasonForSubmission) {
          fieldData.options = disableOptions(
            fieldData.options,
            WLSPendingValidationReasons.ExpiredOffers,
            true
          );
        }
        if (
          fieldData &&
          fieldData.options &&
          step === 1 &&
          fieldData.name === reasonForSubmission
        ) {
          const ind = locale === 'en-US' ? 0 : 1;
          const updatedOptions = getUpdatedOptions(fieldData.options, [
            WLSPendingValidationReasons.ExpiredOffers[ind]
          ]);
          fieldData.options = [...updatedOptions];
        }

        result = (
          <FormField key={key} data={fieldData} error={error && error.text} />
        );
      }

      return result;
    });

  const getSummary = () => {
    if (formSummary) {
      const {
        fields: { formSummaryGroup }
      } = formSummary;

      return formSummaryGroup.map((summaryGroup, index) => {
        const {
          fields: { name, formFields: summaryGroupFields }
        } = summaryGroup;
        const key = `formSummaryGroup${index}`;

        return (
          <Fragment key={key}>
            <h1>{name}</h1>
            <SummaryGroupWrapper>
              {summaryGroupFields.map((summaryGroupField, idx) => {
                const {
                  fields: { name: fieldName, label: fieldLabel }
                } = summaryGroupField;
                const summaryGroupFieldKey = `summaryGroupField${idx}`;

                return (
                  <div key={summaryGroupFieldKey}>
                    <span style={{ fontWeight: '400' }}>{fieldLabel}</span>:{' '}
                    {formFields[fieldName].value}
                  </div>
                );
              })}
            </SummaryGroupWrapper>
          </Fragment>
        );
      });
    }
    return Object.keys(formFields).map((item, index) => {
      const key = `summary${index}`;

      return (
        formFields[item].isVisible && (
          <div key={key}>
            <span style={{ fontWeight: '400' }}>{item}</span>:{' '}
            {formFields[item].value}
          </div>
        )
      );
    });
  };
  // useEffect(() => {
  //   const errors = getErrors(formStepFields, { ...formErrors });
  //   setFormErrors(errors);
  // }, [fieldRequiredMessage, formStepFields]);
  return (
    <div ref={formStepRef}>
      {!hideProgressBar && (
        <ProgressBar
          name={formStepName}
          steps={isChannelSevenX ? steps.slice(1) : steps}
          currentStep={isChannelSevenX ? step - 1 : step}
          locale={locale}
        />
      )}
      <div></div>
      {isLoading ? (
        <ValidateLoader
          message="Please wait request is In progress...."
          isFormStep
        />
      ) : (
        <div style={{ backgroundColor: '#fff' }}>
          <div className="container 85%">
            <div id="main">
              <div id="main-wrapper">
                <div id="main-content">
                  {formStepBackendKey ===
                  BACKEND_KEYS.wirelessOrderDetailsStep ? (
                    <WirelessOrderDetails
                      formStepFields={formStepFields}
                      formFields={formFields}
                      orderData={orderData}
                      setFormFields={setFormFields}
                      isFormTouched={isFormTouched}
                      formErrors={formErrors}
                      onBackClick={prevStep}
                      getErrors={getErrors}
                      setFormErrors={setFormErrors}
                      onFormSubmit={onFormSubmit}
                      onSaveAndExit={saveAndExit}
                    />
                  ) : (
                    <form
                      name={formStepName}
                      onSubmit={e => nextStep(e)}
                      ref={ref => setFormRef && setFormRef(ref)}
                    >
                      <FormFieldsWrapper
                        style={{
                          marginBottom:
                            formName === wirelessOrderForm ? '10rem' : '2rem'
                        }}
                      >
                        <div className={step !== 6 ? 'column' : ''}>
                          {formStepFields ? (
                            renderFormFields(formStepFields)
                          ) : (
                            <>
                              <h3 style={{ marginBottom: '1em' }}>
                                {summaryLabel}
                              </h3>
                              {getSummary()}
                            </>
                          )}
                        </div>
                      </FormFieldsWrapper>
                    </form>
                  )}
                  {
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      {formName === wirelessLandingPageForm && step === 1 && (
                        <LandingText />
                      )}
                      {image && (
                        <FormStepImageContainer>
                          <Image image={image} name={formStepName} />
                        </FormStepImageContainer>
                      )}
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {formName === 'Wireless_Online_Form' &&
        formStepBackendKey !== BACKEND_KEYS.wirelessOrderDetailsStep && (
          <WlsStatusBar
            isFormTouched={isFormTouched}
            onSaveAndExit={saveAndExit}
            onProceedClick={nextStep}
            onBackClick={prevStep}
            step={step}
            isLastStep={steps.length === step}
            firstStepOverride={isChannelSevenX && 2}
            shouldHideSubmit={shouldHideSubmit}
            orderId={orderData.id}
            hasSendToCustomerOption={isChannelSevenX}
          />
        )}
      {
        <Modal
          heading={modalData.title}
          bodyText={modalData.body}
          confirmCTAText={modalData.confirmText}
          cancelCTAText={modalData.cancelText}
          onConfirm={() =>
            history.push({
              pathname: '/'
            })
          }
          onClose={() => setModalData({ ...modalData, open: false })}
          isOpen={modalData.open}
          focusElementAfterClose={formStepRef}
        />
      }
    </div>
  );
};

FormStepWLS.propTypes = {
  stepData: PropTypes.shape({
    fields: PropTypes.shape({
      name: PropTypes.string,
      image: PropTypes.string,
      formStepFields: PropTypes.arrayOf(PropTypes.object),
      formSummary: PropTypes.shape({
        fields: PropTypes.objectOf(PropTypes.any)
      }),
      showTotal: PropTypes.bool,
      modalForms: PropTypes.arrayOf(PropTypes.object),
      backendKey: PropTypes.string
    })
  }),
  steps: PropTypes.arrayOf(PropTypes.object).isRequired,
  step: PropTypes.number.isRequired,
  updateStep: PropTypes.func,
  setFormRef: PropTypes.func,
  onFormSubmit: PropTypes.func,
  onSaveAndExit: PropTypes.func,
  orderData: PropTypes.objectOf(PropTypes.any),
  setOrderData: PropTypes.func,
  hideProgressBar: PropTypes.bool,
  isEditing: PropTypes.string.isRequired,
  formName: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};

FormStepWLS.defaultProps = {
  stepData: null,
  updateStep: () => {},
  setFormRef: null,
  onFormSubmit: null,
  orderData: {},
  setOrderData: () => {},
  onSaveAndExit: () => {},
  hideProgressBar: false
};

export default FormStepWLS;
